<div class="form-row">
    <div class="col-md-4">
        <div class="form-group">
            <span class="sprt traveller"></span>
            <form [formGroup]="travellerForm" class="needs-validation" novalidate
                (validSubmit)="onSubmitTraveller()">
                <div class="totlall">
                    <span class="remngwd" (click)="travellersFadeinn=!travellersFadeinn; fadeinn=false">
                        <span class="total_pax_count">
                            {{travellerForm.get('adults').value + travellerForm.get('childrens').value + travellerForm.get('infants').value}} 
                            &nbsp;</span>
                        <span id="travel_text">Travellers</span>
                    </span>
                    <div class="roomcount pax_count_div {{travellersFadeinn ? 'fadeinn' : ''}}"
                        *ngIf="travellersFadeinn">
                        <div class="inallsn">
                            <div class="oneroom fltravlr">
                                <div class="lablform2">Travellers</div>
                                <div class="clearfix"></div>
                                <div class="roomrow">
                                    <div class="celroe col-md-7">
                                        <i class="fa fa-male"></i> Adults
                                        <span class="agemns">(12+)</span>
                                    </div>
                                    <div class="celroe col-md-5">
                                        <div class="input-group countmore pax-count-wrapper adult_count_div">
                                            <span class="input-group-btn">
                                                <button (click)="onUpdateTraveller('adults', 'minus')" type="button"
                                                    class="btn btn-default btn-number" data-type="minus"
                                                    data-field="adult">
                                                    <span class="fa fa-minus"></span>
                                                </button>
                                            </span>
                                            <input formControlName="adults" type="text" id="OWT_adult" name="adult"
                                                class="form-control input-number centertext valid_class pax_count_value"
                                                value="1" min="1" max="9" readonly="">
                                            <span class="input-group-btn">
                                                <button (click)="onUpdateTraveller('adults', 'plus')" type="button"
                                                    class="btn btn-default btn-number" data-type="plus"
                                                    data-field="adult">
                                                    <span class="fa fa-plus"></span>
                                                </button></span>
                                        </div>
                                    </div>
                                </div>

                                <div class="roomrow">
                                    <div class="celroe col-md-7">
                                        <i class="fa fa-child"></i>
                                        Children<span class="agemns">(2-11)</span>
                                    </div>
                                    <div class="celroe col-md-5">
                                        <div class="input-group countmore pax-count-wrapper child_count_div">
                                            <span class="input-group-btn">
                                                <button (click)="onUpdateTraveller('childrens', 'minus')"
                                                    type="button" class="btn btn-default btn-number"
                                                    data-type="minus" data-field="child">
                                                    <span class="fa fa-minus"></span>
                                                </button>
                                            </span>
                                            <input formControlName="childrens" type="text" id="OWT_child"
                                                name="child"
                                                class="form-control input-number centertext pax_count_value"
                                                value="0" min="0" max="9" readonly="">
                                            <span class="input-group-btn">
                                                <button (click)="onUpdateTraveller('childrens', 'plus')"
                                                    type="button" class="btn btn-default btn-number"
                                                    data-type="plus" data-field="child">
                                                    <span class="fa fa-plus"></span>
                                                </button>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="roomrow last">
                                    <div class="celroe col-md-7">
                                        <i class="fa fa-child"></i> Infants
                                        <span class="agemns">(0-2)</span>
                                    </div>
                                    <div class="celroe col-md-5">
                                        <div class="input-group countmore pax-count-wrapper infant_count_div">
                                            <span class="input-group-btn">
                                                <button (click)="onUpdateTraveller('infants', 'minus')"
                                                    type="button" class="btn btn-default btn-number"
                                                    data-type="minus" data-field="infant">
                                                    <span class="fa fa-minus"></span>
                                                </button>
                                            </span>
                                            <input formControlName="infants" type="text" id="OWT_infant"
                                                name="infant"
                                                class="form-control input-number centertext pax_count_value"
                                                value="0" min="0" max="9" readonly="">
                                            <span class="input-group-btn">
                                                <button (click)="onUpdateTraveller('infants', 'plus')" type="button"
                                                    class="btn btn-default btn-number" data-type="plus"
                                                    data-field="infant">
                                                    <span class="fa fa-plus"></span>
                                                </button>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <!-- Infant Error Message-->

                                <button type="submit" class="done1 comnbtn_room1"><span class="fa fa-check"></span>
                                    Done</button>
                                <!-- Infant Error Message-->
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="col-md-4">
        <div class="form-group">
            <span class="sprt cabin"></span>
            <div class="alladvnce">
                <span class="remngwd" id="choosen_airline_class"
                    (click)="fadeinn=!fadeinn; travellersFadeinn=false">
                    {{regConfig.get('cabinClass').value ? regConfig.get('cabinClass').value : 'Economy'}}
                </span>
                <input type="hidden" autocomplete="off" name="v_class" id="class" value="Economy">
                <div class="advncedown spladvnce class_advance_div {{fadeinn? 'fadeinn': ''}}" *ngIf="fadeinn">
                    <div class="inallsnnw">
                        <div class="scroladvc">
                            <a (click)="onChangeCabin('Economy')" class="adscrla choose_airline_class active"
                                data-airline_class="Economy">Economy</a>
                            <a (click)="onChangeCabin('Premium Economy')" class="adscrla choose_airline_class "
                                data-airline_class="PremiumEconomy">Premium
                                Economy</a>
                            <a (click)="onChangeCabin('Business')" class="adscrla choose_airline_class "
                                data-airline_class="Business">Business</a>
                            <a (click)="onChangeCabin('First')" class="adscrla choose_airline_class "
                                data-airline_class="First">First</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4">
        <div class="form-group">
            <button type="submit" class="btn w-100 src_btn btn--primary">
                Search Flights
            </button>
        </div>
    </div>
</div>